import type { ApiConfig } from '../../types'

export const depositHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 100,
  order: 'desc',
  range: 90 * 24 * 60 * 60 * 1000, // 90 days in milliseconds
  requiresRange: true,
  type: 'deposit-history',
} as const satisfies ApiConfig
